import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  AllRegion_LIST_START: "AllRegion_LIST_START",
  AllRegion_LIST_SUCCESS: "AllRegion_LIST_SUCCESS",
  AllRegion_LIST_FAILED: "AllRegion_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const AllRegionListStart = (data) => ({
  type: actionType.AllRegion_LIST_START,
  payload: data,
});

export const AllRegionListSuccess = (data) => ({
  type: actionType.AllRegion_LIST_SUCCESS,
  payload: data,
});

export const AllRegionListFailed = (data) => ({
  type: actionType.AllRegion_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function AllRegionListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.AllRegion_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.AllRegion_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.AllRegion_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* AllRegionListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      const AllRegion = response.data.data.allRegions?.Regions
        ? response.data.data.allRegions?.Regions
        : null;
      let finalData = [];
      yield put(AllRegionListSuccess(AllRegion));
    } else {
      messagePopup("", "COLLEGE List failed", "error");
      yield put(AllRegionListFailed("AllRegion List failed"));
    }
  } catch (error) {
    messagePopup("", "AllRegion List failed", "error");
    yield put(AllRegionListFailed("AllRegion List failed"));
  }
}

export function* watchAllRegionListSaga() {
  yield takeEvery(actionType.AllRegion_LIST_START, AllRegionListSaga);
}
